import { render, staticRenderFns } from "./AnalyDead.vue?vue&type=template&id=dc907a3a&"
import script from "./AnalyDead.vue?vue&type=script&lang=js&"
export * from "./AnalyDead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports